import { render, staticRenderFns } from "./SegmentChart.vue?vue&type=template&id=1052bdea"
import script from "./SegmentChart.vue?vue&type=script&lang=js"
export * from "./SegmentChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports